<template>
	<div class="ProductPlatform">
		<div class="title">
			<p class="frist">{{ lang.index_products_plat }}</p>
			<p class="second">{{ lang.index_products_info }}</p>
		</div>
		<div class="Product container-main">
			<div class="productList">
				<div class="productItem" v-for="(cate, index) in cate_list" :key="index" v-if="index < 7">
					<div class="productItemInfo" :style="{ backgroundImage: `url(${cate.img})` }">
						<h5>namew</h5>
						<p class="name-line"></p>
					</div>
				</div>
				<div class="productItem">
					<div class="productItemInfo" style="justify-content: center;align-items: center;"
						:style="{ backgroundImage: 'url(' + require('@/assets/index/more_bj.png') + ')' }"
						@click="path('/productplatform/index/0')">
						<div class="more">
							<img src="../../assets/index/arrow-more.png"
								style="margin: 0 0.75rem;width: 1.25rem;height: 1.25rem;" />
							<div class="see">{{ lang.index_view_more }}</div>
						</div>

					</div>
				</div>
			</div>
			<!-- <el-row style="display: flex;flex-wrap: wrap;">
				<el-col :xs="12" :sm="6" :lg="6" v-for="(cate, index) in cate_list" v-if="index < 7">
					<div class="grid-content bg-purple cursor" :style="{ backgroundImage: `url(${cate.img})` }"
						@click="path('/productplatform/index/' + cate.id)">
						<div class="Product-type">
							<h5>{{ cate.name }}</h5>
							<p></p>
						</div>
					</div>
				</el-col>
				<el-col :xs="12" :sm="6" :lg="6">
					<div class="grid-content cursor" style="align-items: center;justify-content: center;"
						:style="{ backgroundImage: 'url(' + require('@/assets/index/more_bj.png') + ')' }"
						@click="path('/productplatform/index/0')">
						<div class="more">
							<div class="title cursor">
								<img src="../../assets/index/arrow-more.png"
									style="margin: 0 0.75rem;width: 1.25rem;height: 1.25rem;" />
								<div class="see">{{ lang.index_view_more }}</div>
							</div>
						</div>
					</div>
				</el-col>
			</el-row> -->
		</div>
	</div>
</template>

<script>
import { getIndexProductCate } from "@/api/store";
import {
	mapState
} from 'vuex'
export default {
	name: "ProductPlatform",
	computed: {
		...mapState({
			lang: state => state.user.lang,
		})
	},
	data() {
		return {
			cate_list: []
		}
	},
	created() {
		this.getIndexProductCate()
	},
	methods: {
		getIndexProductCate() {
			getIndexProductCate().then(res => {
				this.cate_list = res.data.cate_list
			})
		},
		path(routePath) {
			this.$router.push(routePath);
		}

	}
};
</script>

<style lang="less">
.ProductPlatform {
	background-color: #fff;
	width: 100%;
	padding: 1.875rem 0;

	/* display: flex;
        justify-content: center;
        align-items: center; */
	.title {
		margin-bottom: 1.9375rem;

		.frist {
			font-family: SourceHanSansCN, SourceHanSansCN;
			font-weight: bold;
			font-size: 1.75rem;
			color: #333333;
			line-height: 0px;
			text-align: center;
			line-height: 1.75rem;
		}

		.second {
			font-size: 0.875rem;
			color: #333333;
			line-height: 0px;
			text-align: center;
		}
	}

	.Product {
		.productList{
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			.productItem{
				width: 25%;
				margin-bottom: 1.56rem;
				.productItemInfo{
					background-repeat: no-repeat;
    				border-radius: .5rem;
					background-size: 100% 100%;
					width: 16rem;
					min-height: 22rem;
					display: flex;
					flex-direction: column;
					justify-content: end;
					margin: 0 auto;
					padding: 0 1rem;
					transition: transform 0.3s ease;
					.name-line{
						width: 2.375rem;
						height: 0.125rem;
						background-color: #333;
						bottom: 0.625rem;
					}
				}
			}
		}
		.productItemInfo:hover {
			transform: scale(1.05);
		}

	}

}

@media (max-width: 1200px) {
	.ProductPlatform .Product .productList .productItem{
		.productItemInfo{
			width: 95%;
			min-height: 22rem;
		}
		.productItemInfo:hover {
			transform: scale(1);
		}
	}
}

@media (max-width:980px) {
	.ProductPlatform .Product .productList .productItem{
		.productItemInfo{
			width: 95%;
			min-height: 18rem;
		}
		.productItemInfo:hover {
			transform: scale(1);
		}
	}
}
@media (max-width: 768px) {

	.ProjectLayout {
		padding-bottom: 3rem;
		height: auto !important;
	}

	.ProjectLayout .Project .container-main .content .Project-content {
		display: none;
	}

	.ProductPlatform .Product .productList .productItem{
		width: 50%;
		.productItemInfo{
			width: 95%;
			min-height: 20rem;
		}
	}
}

@media (min-width: 570px) and (max-width: 768px) {

	.ProjectLayout {
		padding-bottom: 3rem;
		height: auto !important;
	}

	.ProjectLayout .Project .container-main .content .Project-content {
		display: none;
	}

	.ProductPlatform .Product .productList .productItem{
		width: 50%;
		.productItemInfo{
			width: 90%;
			min-height: 25rem;
		}
	}
}
@media (max-width: 480px) {
	.ProductPlatform .Product .productList .productItem{
		width: 50%;
		.productItemInfo{
			width: 95%;
			min-height: 15.5rem;
		}
		.productItemInfo:hover {
			transform: scale(1);
		}
	}
    .more{
		width: 100% !important;
    }
}
</style>
  <style scoped lang="less">
  
    .more{
		width: 10rem;
		height: 3.44rem;
		color: #333;
		border: 1px solid #333;
		display: flex;
		justify-content: center;
		align-items: center;
      
      .title{
        width: 10rem;
        height: 3.44rem;
        color: #333333;
        border: 1px solid #333333;
        display: flex;
        justify-content: center;
        align-items: center;
        .see{
          font-family: MicrosoftYaHei;
          font-size: 1rem;
          color: #333333;
        }
      }
    }
  </style>
  